/**
 * FacetAccordion.Item pads every open section's bottom to clear the divider below it.
 * The last section has no divider, and the Drawer body already pads the panel, so drop it there.
 */
export const sectionClasses = 'last:data-[state=open]:pb-0';
